import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sz-live-dot',
  template: '',
  styleUrls: ['./sz-live-dot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzLiveDotComponent {}
